import { TQuoteApiResponse } from '@models/quotes';

/** Helper function to get an array of all quote ids for a multi policy quote */
export const getMultiPolicyQuoteIds = (quote?: TQuoteApiResponse) => {
  if (!quote) {
    return [];
  }

  const { multiPolicyQuoteDestinations, multiPolicyQuoteSource, id } = quote ?? {};
  const quoteIds = [];
  quoteIds.push(id);
  multiPolicyQuoteDestinations?.forEach((q) => {
    if (q.destinationQuote && id !== q.destinationQuote?.id) {
      quoteIds.push(q.destinationQuote.id);
    }
  });
  if (multiPolicyQuoteSource?.sourceQuote?.id && id !== multiPolicyQuoteSource?.sourceQuote?.id) {
    quoteIds.push(multiPolicyQuoteSource?.sourceQuote?.id);
  }

  return quoteIds;
};
